// @flow
import CopyDishesModal from './CopyDishesModal';

export default CopyDishesModal;
